import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { userNormalLogout, supportLogout } from "../actions";

export interface AccountingState {
  reconAggregationData: {};
  uploadedReportsMetaData: {};
  orderwisePayoutData: {};
  cashManagementData: {};
  cashManagementSummary: {};
  accountingSummary: [];
  salesSummaryByBrand: [];
  billsDetails:{},
  paymentSummary:[],
  invoiceDetails:{},
  paymentUserSummary:[],
  userSummary:[],
  sendDigitalBillViaEmailResponse: {},
  userCreditDetails:{},
  creditSummary:[],
  auditDetails:{},
  auditFilterDetails:{},
  currentTransactionDetails: {};
  isDataFetched: boolean;
  sendDigitalBillViaWAResponse: {};
  sendDigitalBillViaSMSResponse: {};
}

const initialState: AccountingState = {
  reconAggregationData: {},
  uploadedReportsMetaData: {},
  orderwisePayoutData: {},
  cashManagementData: {},
  cashManagementSummary: {},
  accountingSummary: [],
  sendDigitalBillViaWAResponse: {},
  salesSummaryByBrand: [],
  userCreditDetails:{},
  paymentSummary:[],
  billsDetails:{},
  invoiceDetails:{},
  userSummary:[],
  paymentUserSummary:[],
  creditSummary:[],
  isDataFetched: false,
  auditFilterDetails:{},
  auditDetails:{},
  sendDigitalBillViaEmailResponse: {},
  sendDigitalBillViaSMSResponse: {},
  currentTransactionDetails: {},
};

export const accountingSlice = createSlice({
  name: "accounting",
  initialState,
  reducers: {
    getReconAggregationData: (state, actions) => {},
    saveReconAggregationData: (state, actions) => {
      state.reconAggregationData = actions.payload;
    },

    getUploadedReportsMetaData: (state) => {},
    saveUploadedReportsMetaData: (state, actions) => {
      state.uploadedReportsMetaData = actions.payload;
    },

    uploadReconFile: (state, actions) => {},
    getOrderwisePayoutData: (state, actions) => {},
    saveOrderwisePayoutData: (state, actions) => {
      let orderwisePayoutDataClone: any =
        cloneDeep(state.orderwisePayoutData) || {};
      if (actions?.payload?.orderType) {
        orderwisePayoutDataClone[actions?.payload?.orderType] =
          actions?.payload?.response || [];
        state.orderwisePayoutData = orderwisePayoutDataClone;
      }
    },
    getCashManagementSummary: (state, actions) => {},
    saveCashManagementSummary: (state, actions) => {
      state.cashManagementSummary = actions.payload;
    },
    getCashManagementList:(state, actions) => {},
    getCurrentTransactionList: (state, actions) => {},
    saveCashManagementList: (state,actions) => {  state.cashManagementData = actions.payload;
    },
    getAccountingSummary: (state, actions) => {},
    saveAccountingSummary: (state, actions) => {
      state.accountingSummary = actions.payload;
    },
    getSaleGroupByBrand: (state, actions) => {},
    saveSaleGroupByBrand: (state, actions) => {
      state.salesSummaryByBrand = actions.payload;
    },
    getPaymentSummary: (state, actions) => {},
    savePaymentSummary: (state, actions) => {
      state.paymentSummary = actions.payload;
    },

    getPaymentUserSummary: (state, actions) => {},
    savePaymentUserSummary: (state, actions) => {
      state.paymentUserSummary = actions.payload;
    },
    getBillsDetails: (state, actions) => {},
    saveBillsDetails: (state, actions) => {
      state.billsDetails = actions.payload;
    },

    getPaymentUserSummaryDetails: (state, actions) => {},
    savePaymentUserSummaryDetails: (state, actions) => {
      state.userSummary = actions.payload;
    },

    getCreditSummary: (state, actions) => {},
    saveCreditSummary: (state, actions) => {
      state.creditSummary = actions.payload;
    },

    getInvoiceDetails: (state, actions) => {},
    saveInvoiceDetails: (state, actions) => {
      state.invoiceDetails = actions.payload;
    },

    getUserCreditDetails: (state, actions) => {},
    saveUserCreditDetails: (state, actions) => {
      state.userCreditDetails = actions.payload;
    },
    sendDigiatlBillViaEmail: (state, action) => {
      state.isDataFetched = true;
    },
    sendDigitalBillViaEmailSuccess: (state, action) => {
      state.sendDigitalBillViaEmailResponse = action.payload;
      state.isDataFetched = false;
    },

    
    getAuditLogDetails: (state, actions) => {},
    saveAuditLogDetails: (state, actions) => {
      state.auditDetails = actions.payload;
    },

    getSubFilterDetails: (state, actions)=>{},
    saveSubFilterDetails: (state, actions)=>{
      state.auditFilterDetails = actions.payload;
    },

    createTransaction: (state, actions) => {},
    getTransactionDetails: (state, actions) => {},
    updateCurrentTransactionData: (state, actions) => {
      state.currentTransactionDetails = actions.payload;
    },
    sendDigitalBillViaSMS: (state, actions) => {
      state.isDataFetched = true;
    },
    sendDigitalBillViaSMSSuccess: (state, actions) => {
      state.sendDigitalBillViaSMSResponse = actions.payload;
      state.isDataFetched = false;
    },

    sendDigiatlBillViaWA: (state, actions) => {
      state.isDataFetched = true;
    },
    sendDigitalBillViaWASuccess: (state, actions) => {
      state.sendDigitalBillViaWAResponse = actions.payload;
      state.isDataFetched = false;
    },

    downloadTrxnAttachment: (state, actions) => {},
    deleteTrxnAttachment: (state, actions) => {},
    updateTransaction: (state, actions) => {},
    uploadTrxnAttachment: (state, actions) => {},
    getFranciseReport: (state, actions) => {}
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getReconAggregationData,
  saveReconAggregationData,
  getUploadedReportsMetaData,
  saveUploadedReportsMetaData,
  uploadReconFile,
  getOrderwisePayoutData,
  getAccountingSummary,
  saveAccountingSummary,
  saveSaleGroupByBrand,
  getPaymentSummary,
  savePaymentSummary,
  getPaymentUserSummary,
  getSaleGroupByBrand,
  savePaymentUserSummary,
  getBillsDetails,
  saveBillsDetails,
  getCreditSummary,
  saveCreditSummary,
  getInvoiceDetails,
  getAuditLogDetails,
  saveInvoiceDetails,
  saveAuditLogDetails,
  saveOrderwisePayoutData,
  getCashManagementSummary,
  saveCashManagementSummary,
  sendDigitalBillViaSMS,
  sendDigiatlBillViaEmail,
  sendDigitalBillViaEmailSuccess,
  getUserCreditDetails,
  getSubFilterDetails,
  saveSubFilterDetails,
  saveUserCreditDetails,
  sendDigiatlBillViaWA,
  sendDigitalBillViaWASuccess,
  getCashManagementList,
  getCurrentTransactionList,
  saveCashManagementList,
  getPaymentUserSummaryDetails,
  savePaymentUserSummaryDetails,
  createTransaction,
  getTransactionDetails,
  updateCurrentTransactionData,
  sendDigitalBillViaSMSSuccess,
  downloadTrxnAttachment,
  deleteTrxnAttachment,
  updateTransaction,
  uploadTrxnAttachment,
  getFranciseReport
} = accountingSlice.actions;
export default accountingSlice.reducer;
